import { createAction, props } from '@ngrx/store';
import { types } from './types';

export const setLoginImage = createAction(
    types.SET_LOGIN_IMAGE,
    props<{
        loginImage: number;
    }>()
);
